var version = "1.26.0";

export default version;
